import { render, staticRenderFns } from "./projectGoodsStats.vue?vue&type=template&id=036611e4&scoped=true&"
import script from "./projectGoodsStats.vue?vue&type=script&lang=js&"
export * from "./projectGoodsStats.vue?vue&type=script&lang=js&"
import style0 from "./projectGoodsStats.vue?vue&type=style&index=0&id=036611e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036611e4",
  null
  
)

component.options.__file = "projectGoodsStats.vue"
export default component.exports